import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { setModalState } from '@actions/quizTaking';
import { calculatorType } from '@constants/index';
import { MODAL_TYPES } from '@cont/Quiz/constants';
import {
  getCalculatorType,
  getCurrentQuestionInfo
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { NTA_COLORS } from '../constants';

const Button = styled.button`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 4px 6px;
  border: 2px solid ${NTA_COLORS.calculatorBorder};
  border-radius: 41px;
  background: ${NTA_COLORS.calculatorBg};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.svg`
  display: block;
  flex-shrink: 0;
`;

const NtaCalculatorButton = () => {
  const dispatch = useDispatch();
  const { sectionUID } = useSelectorWithShallowEqual(getCurrentQuestionInfo);
  const sectionalCalculatorType = useSelectorWithShallowEqual(
    getCalculatorType(sectionUID)
  );

  const showCalculator =
    calculatorType.CALCULATOR_NOT_SELECTED !== sectionalCalculatorType;

  if (!showCalculator) {
    return null;
  }

  const handleClick = () => {
    dispatch(
      setModalState({
        type: MODAL_TYPES.QUIZ_CALCULATOR,
        data: {
          calculatorType: sectionalCalculatorType,
          isTestRevampFlow: false
        }
      })
    );
  };

  return (
    <Button type="button" onClick={handleClick} aria-label="Calculator">
      <Icon width="14" height="18" viewBox="0 0 14 18" fill="none" aria-hidden>
        <rect
          x="0.617"
          y="0.617"
          width="12.765"
          height="16.765"
          rx="1.647"
          stroke={NTA_COLORS.calculatorIcon}
          strokeWidth="1.235"
        />
        <rect
          x="3.088"
          y="2.471"
          width="9.059"
          height="4.941"
          rx="0.824"
          stroke={NTA_COLORS.calculatorIcon}
          strokeWidth="1.235"
        />
        <rect
          x="2.471"
          y="9.176"
          width="8.824"
          height="1.647"
          fill={NTA_COLORS.calculatorIcon}
        />
        <rect
          x="2.471"
          y="12.706"
          width="8.824"
          height="1.647"
          fill={NTA_COLORS.calculatorIcon}
        />
      </Icon>
    </Button>
  );
};

export default NtaCalculatorButton;
